import React from "react";

import "./static-bonus.scss";
import LoaderContainer from "../../mui/loader_container/LoaderContainer";
import { useAppSelector } from "../../../store/index.ts";
import Welcome from "./welcome/Welcome.jsx";
import Cashback from "./cashback/Cashback.jsx";
import ErrorBoundary from "../../mui/error_boundary/ErrorBoundary.jsx";
import FreeSpin from "../free_spin/FreeSpin.jsx";
import { ENUM_PROMOTION_STATUS } from "./../../../store/enums.js";
import ShowContainer from "../../mui/ShowContainer.jsx";

export default function StaticBonus() {
  // const { t } = useTranslation();
  // const { bonuses } = useGetBonus();
  const forUser = useAppSelector((state) => state.promotions.forUser);
  const welcome = useAppSelector((state) => state.promotions.welcome);

  return (
    <div className="static-bonus">
      {/* <h2>
        <IconBonus /> {t("Bonuses")}
      </h2> */}

      <LoaderContainer loader={forUser === ENUM_PROMOTION_STATUS.loading} center>
        <ErrorBoundary>
          <ShowContainer condition={welcome?.id}>
            <Welcome />
          </ShowContainer>
        </ErrorBoundary>
        <ErrorBoundary>
          <Cashback />
        </ErrorBoundary>

        <ErrorBoundary>
          <FreeSpin />
        </ErrorBoundary>

        {/* <div className="static-bonus__bonuses">
          {bonuses.map((el) => (
            <StaticBonusItem bonus={el} key={el.id} />
          ))}
        </div> */}
      </LoaderContainer>

      {/* <ShowContainer condition={forUser === ENUM_PROMOTION_STATUS.error}>
        <h1> Произошла ошибка зайдите на страницу позже </h1>
      </ShowContainer> */}
    </div>
  );
}
